import { render, staticRenderFns } from "./ViewPlotDetails.vue?vue&type=template&id=14b33536"
import script from "./ViewPlotDetails.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails.vue?vue&type=script&lang=ts"
import style0 from "./ViewPlotDetails.vue?vue&type=style&index=0&id=14b33536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports